import { call, put, takeLatest } from "redux-saga/effects";
import {
  FETCH_INVENTORY_LOCATIONS_FETCH,
  fetchInventoryLocationsSuccess,
} from "./action"; // corrected relative path
import api from "src/util/api";
import { showErrorNotification } from "src/util/notifications";
import { INVENTORY_POST_LOCATIONS_URL } from "src/util/constants/api.constants";


export function* fetchInventoryPostLocation(): Generator {
  try {
    let url = INVENTORY_POST_LOCATIONS_URL.INVENTORY_POST_LOCATIONS;
    const data: any = yield call(api.get, url);
    yield put(fetchInventoryLocationsSuccess(data));
  } catch (e: any) {
    showErrorNotification(null, e);
  }
}

export function undoInventoryPost(payload: any) {
  try {
    let url = INVENTORY_POST_LOCATIONS_URL.UNDO_POSTED_INVENTORY;
    return api.put(url, payload);
  } catch (e: any) {
    showErrorNotification(null, e);
  }
}
